/**
 * Adds utm_source=pitch2table.com to a URL
 * @param {string} url - The URL to add UTM parameters to
 * @returns {string} The URL with UTM parameters added, or undefined if input is undefined
 */
export const addUtmSource = (url) => {
  if (!url) {
    return url;
  }

  try {
    const urlObj = new URL(url);

    // Add utm_source parameter
    urlObj.searchParams.set("utm_source", "pitch2table.com");

    return urlObj.toString();
  } catch (e) {
    // If URL parsing fails, return the original URL
    return url;
  }
};
